import React from "react"
import { Box, Container, Text, Flex, Heading, Grid } from "theme-ui"
import { InboundLink } from "./link"
import { getProductPath } from "../utils/path"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { GatsbyImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"

const ProjectCardCollection = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  const { projects } = block

  return (
    <Container sx={{ mt: [3, 5, 6, 6] }}>
      <Grid
        columns={[1, 2, 3, 4]}
        sx={{
          gap: [3, 3, 4, 4],
          a: {
            textDecoration: "none",
          },
        }}
      >
        {projects.map((project, index) => (
          <InboundLink to={getProductPath(project, locale)} key={index}>
            <ProjectCard key={index} project={project} />
          </InboundLink>
        ))}
      </Grid>
    </Container>
  )
}

const ProjectCard = ({ project }) => {
  const { title, page, imageThumb } = project

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ ease: "easeInOut", duration: 0.2 }}
    >
      <Flex
        sx={{
          flexDirection: "column",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: "100%",
            borderRadius: "80px",
            overflow: "hidden",

            ".gatsby-image-wrapper": {
              minWidth: "100%",
              height: "100%",
            },
          }}
        >
          <GatsbyImage image={imageThumb.gatsbyImageData} />
        </Box>
        <Box sx={{ my: 4 }}>
          <Text
            sx={{
              fontSize: 1,
              textTransform: "uppercase",
              color: "primary",
              fontWeight: 500,
              fontFamily: "mono",
            }}
          >
            {page.title}
          </Text>
          <Heading
            as="h2"
            sx={{
              mt: [2, 2, 3],
              fontSize: 1,
              lineHeight: 1.5,
              textTransform: "uppercase",
              color: "dark",
              fontWeight: 500,
              fontFamily: "mono",
            }}
          >
            {title}
          </Heading>
        </Box>
      </Flex>
    </motion.div>
  )
}

export default ProjectCardCollection
